import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button} from '@material-ui/core';
import TextField from '@mui/material/TextField';
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
// import { makeStyles } from "@material-ui/core/styles";
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import FileManagement from '../components/FileManagement';
import axios from 'axios';
import { useSelector } from 'react-redux';
import * as env from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

// const useStyles = makeStyles({
//   paper: {
//     fontSize: '12px !important',    
//   }
// });

var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {  
  const childRefFM = React.useRef();
  ///const classes = useStyles();
  const userObj = useSelector(state => state.userDetails);
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [savingBtn, setSavingBtn] = React.useState(false);
  
  const [postStatus, setPostStatus] = React.useState("Draft");
  const [publicDisplay, setPublicDisplay] = React.useState(true);
  const [makeCurrentDisplayDate, setMakeCurrentDisplayDate] = React.useState(false);

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}

  const handlePublicDisplay = (event) => {
    setPublicDisplay(event.target.checked);
  };

  const handleMakeCurrentDisplayDate = (event) => {
    setMakeCurrentDisplayDate(event.target.checked);
  };
  
  React.useEffect(() => {	
    setSavingBtn(false);

    if(open && props.dataObj && props.dataObj.autoId>0){
      setPostStatus(props.dataObj.postStatus);
      if(props.dataObj.publicDisplay===1){
        setPublicDisplay(true);
      }else{
        setPublicDisplay(false);
      }

    }else{
      setPostStatus("Draft");
      setPublicDisplay(true);
    
    }
	}, [open,userObj,props.dataObj]);



	function saveData(){  

		if(postStatus && postStatus.length>1){ 
			let axiosHeader = {
				headers:{
				  'Content-Type': 'multipart/mixed',
				  'loginId': userObj.obj?.loginId,
				  'token': userObj.obj?.token,
				  'device': 'web'
				}
			};
			const data = new FormData();
      if(props.dataObj && props.dataObj.autoId>0){
        data.append('id', props.dataObj.autoId);
      }
      data.append('postStatus', postStatus);
    
      if(publicDisplay===true){
        data.append('publicDisplay', 1);
      }else{
        data.append('publicDisplay', 0);
      }

      if(makeCurrentDisplayDate===true){
        data.append('changeDisplayDateFlag', 1);
      }else{
        data.append('changeDisplayDateFlag', 0);
      }

      let apiURL='/admin/posts-update-status';
      let myMessage="Post has been updated.";

      setSavingBtn(true);  
			axios.post(env.API_URL+apiURL, data, axiosHeader)
			.then((response) => {
        setSavingBtn(false);
				///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
          setSeverityAlert("success");
          setOpen(false);
					setShowAlert(true);
					setAlertMessage(myMessage);
          props.reload();		
					return false;
				}else{
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("This post could not be saved.");			
					return false;
				}
			})
			.catch((error) => {
				console.log("AXIOS ERROR: ", error);
			})	
		}		
	}

  
  return (
    <>
      <Dialog fullWidth maxWidth="lg" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent >
            <Grid item   md={12} xs={12} className="test-instructions" >
                  <div className="btmbdrgry"><h3>{props?.dataObj?.channelName}/{props?.dataObj?.categoryName}/{props?.dataObj?.postTitle}</h3></div>
                  
            <Box mt={1}>
							<Grid container spacing={2}>                
								<Grid item md={12} xs={12}>      
                      <table style={{backgroundColor:'#000000',width:'100%' }} cellSpacing="1" cellPadding="3" >
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>
                              <b>{props?.dataObj?.postTitle}</b><br/>
                              {props?.dataObj?.postSubTitle}<br/><br/>
                              <img src={props?.dataObj?.postImageUrl+'/'+props?.dataObj?.postImage} height={100} />
                              <br/><br/>
                              {(props.dataObj && props.dataObj.postDescription && props.dataObj.postDescription.length>0)?
                                <div dangerouslySetInnerHTML={{ __html: props.dataObj.postDescription }} />
                              :null}

                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>
                              SEO Meta Title: {props?.dataObj?.seoTitle}
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>
                              SEO Meta Description: {props?.dataObj?.seoDescription} 
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>
                              SEO Meta Keywords: {props?.dataObj?.seoKeywords}
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>
                              SEO Meta Tags: {props?.dataObj?.seoTags}
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                          <td>
                            Tags: {props?.dataObj?.tags}
                          </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>
                              Display Date: {props?.dataObj?.displayDate}
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>
                              Source: {props?.dataObj?.source}
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>
                                <Select  
                                  label="Country"
                                  style={{width:'100%'}}
                                  labelId="select-class-labela"
                                  id="select-classa"
                                  value={postStatus}									
                                  onChange={event => setPostStatus(event.target.value)}
                                  variant="standard"
                                >
                                  <MenuItem value="Draft" >Draft</MenuItem>
                                  <MenuItem value="In_Review" >In_Review</MenuItem>
                                  <MenuItem value="Approved" >Approve</MenuItem>
                                  <MenuItem value="Published" >Publish</MenuItem> 
                                </Select>
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td colSpan={2} >
                              <FormControlLabel
                                  label="Display for Public"
                                  control={
                                    <Checkbox
                                      checked={publicDisplay}
                                      onChange={handlePublicDisplay}
                                    />
                                  }
                                />     
                            </td>                            
                        </tr>
                        
                        {(publicDisplay===true && userObj?.obj?.userType && userObj?.obj?.userType==1)?
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td colSpan={2} >
                              <FormControlLabel
                                  label="Make Current Display Date"
                                  control={
                                    <Checkbox
                                      checked={makeCurrentDisplayDate}
                                      onChange={handleMakeCurrentDisplayDate}
                                    />
                                  }
                                />     
                            </td>                            
                        </tr>
                        :null}

                      </table>
                      <Box mt={2}>
                          <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
                          {savingBtn?                
                          <LoadingButton loading loadingPosition="start" startIcon={<SaveIcon />} style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} size="small" variant="outlined" >Saving...</LoadingButton>
                          :<Button onClick={() => {saveData()}} size="small" variant="contained" style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} >Save</Button>
                          } 
								      </Box>
                </Grid>
              </Grid>
            </Box>              
                  
            </Grid>
          </DialogContent>
      </Dialog>
      
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

    </>
  );

});

export default CustomizedDialogs;